<div class="login-content d-flex flex-column alig-items-center">
  <div
    *ngIf="loginCustomization"
    class="login-logo mx-auto p-3"
  >
    <img
      [src]="loginCustomization.logoLogin | fileUrl"
      class="img-fluid"
    />
    <h1 class="text-center text-white">IoT Suite</h1>
  </div>
  <div class="login-elements">
    <router-outlet></router-outlet>
  </div>
  <nav
    *ngIf="loginCustomization.footer"
    class="footer-navbar navbar navbar-light bg-light text-center"
  >
    <span class="navbar-text">
      <span>{{'message.copyright' | translate}}</span>
      <span>{{'label.gieseckeDevrientGmbh' | translate}}</span>.
      <span>{{'message.allRightsReserved' | translate}}</span>
    </span>
  </nav>
</div>
